import { useFormContext } from 'react-hook-form';

import { HubspotFormField } from '@/components/forms/HubspotFormNew/HubspotFormField';

export const HubspotFormOriginal = ({ formData }: any) => {
  const variant = 'original';
  const {
    control,
    formState: { errors, isSubmitting },
  } = useFormContext();

  const { submitText, formFieldGroups, guid } = formData;

  return (
    <>
      <div>
        {formFieldGroups?.map((fieldGroup, index) => (
          <fieldset
            className={`form-columns-${fieldGroup.fields.length}`}
            // eslint-disable-next-line react/no-array-index-key
            key={`fieldGroup-${index}`}
          >
            {fieldGroup.fields.map((field) => (
              <HubspotFormField
                formId={guid}
                key={field.name}
                field={field}
                control={control}
                error={errors[field.name]}
                variant={variant}
              />
            ))}
            {fieldGroup.richText?.type === 'TEXT' && (
              <div
                className="hs-richtext"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: fieldGroup.richText.content,
                }}
              />
            )}
          </fieldset>
        ))}
      </div>
      <div className="hs-submit">
        <button className="hs-button" type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : submitText}
        </button>
      </div>
    </>
  );
};
